module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution3_2-0d5008784db7708370bbafbfb33fa648.png";